import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { HoverGradientDirective } from '../shared/directives/hover-gradient.directive';

@Component({
  selector: 'app-commitment',
  imports: [
    NgOptimizedImage,
    NgxTolgeeModule,
    HoverGradientDirective,
    RouterLink,
  ],
  templateUrl: './commitment.component.html'
})
export class CommitmentComponent {
  cards = [
    { link: 'nous-rejoindre', text: 'joinUs', image: "assets/images/rh/rh-1.webp" },
    { link: 'nos-valeurs', text: 'ourValues', image: "assets/images/rh/rh-5.webp" },
    { link: 'politiques-rh', text: 'hrPolicies', image: "assets/images/rh/rh-7.webp" },
    { link: 'social-environment', text: 'socialEnvironment', image: "assets/images/rh/rh-11.webp" },
  ];
}
